import React, { Component } from 'react';
import axios from 'axios';
import Cookies from 'universal-cookie';

import { FETCH_URL } from '../../constants/ServerLinks';
import './Dashboard.scss';
import GraphManager from '../../components/graph-display/GraphManager';
import PeerRanking from '../../components/peer-ranking/PeerRanking';
import Button from '@material-ui/core/Button/Button';
import Snackbar from '@material-ui/core/Snackbar';
import Metrics from '../../components/metrics/Metrics';
import { inject, observer } from 'mobx-react';
import PropTypes from 'prop-types';

const nFormatter = (num, digits) => {
  let isNegative = false;
  if (num < 0) {
    isNegative = true;
    num *= -1;
  }
  const si = [
    { value: 1, symbol: '' },
    { value: 1e3, symbol: 'k' },
    { value: 1e6, symbol: 'M' },
    { value: 1e9, symbol: 'B' },
    { value: 1e12, symbol: 'T' },
    { value: 1e15, symbol: 'P' },
    { value: 1e18, symbol: 'E' },
  ];
  const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
  let i;
  for (i = si.length - 1; i > 0; i--) {
    if (num >= si[i].value) {
      break;
    }
  }

  if (isNegative) {
    num *= -1;
  }

  return (num / si[i].value).toFixed(digits).replace(rx, '$1') + si[i].symbol;
};

@observer
class Dashboard extends Component {
  constructor(props) {
    super(props);

    this.fetchURL = FETCH_URL;
    this.cookies = new Cookies();
    this.countryId = this.cookies.get('country_id');
    this.roleId = this.cookies.get('role_id');
    this.world_skey = this.cookies.get('world_skey');

    this.state = {
      metrics: {
        year: {
          name: 'Year',
          text: () => {},
          value: () => {},
        },
        next_budget: {
          name: 'Budget',
          text: () => {},
          value: () => {},
        },
        budgetou: {
          name: 'Over(+)/Under(-) Budget',
          text: () => {},
          value: () => {},
        },
        debt: {
          name: '% in Debt',
          text: () => {},
          value: () => {},
        },
        cost: {
          name: 'Policy Costs',
          text: () => {},
          value: () => {},
        },
        gdp: {
          name: '% GDP Change',
          text: () => {},
          value: () => {},
        },
        employ: {
          name: 'Employment',
          text: () => {},
          value: () => {},
        },
        hrt: {
          name: 'HRX',
          text: () => {},
          value: () => {},
        },
        eqt: {
          name: 'Equity',
          text: () => {},
          value: () => {},
        },
        favorability: {
          name: 'Favorability',
          text: () => {},
          value: () => {},
        },
        discord: {
          name: 'Political Stress',
          text: () => {},
          value: () => {},
        },
      },
      objectives: {},
      reasoning: [],
      plotData: {},
      countries: props.countries.countries,
      snackMsg: 'Welcome!',
      snackOpen: false,
      snackType: 'snack-success',
      snackAutoHideDuration: null,
      requestSent: false,
      rankingAllowed: false,
    };

    this.updateMetrics()
      .then(this.fetchAll)
      .catch(this.fetchAll);
  }

  fetchAll = () => {
    axios
      .all([
        axios.get(this.fetchURL + '/api/v1/objectives/', {
          params: {
            country_id: this.countryId,
          },
        }),
        // axios.get(this.fetchURL + '/api/v1/policies/reasoning/', {
        //     params: {
        //         country_id: this.countryId,
        //     }
        // }),
        // axios.get(this.fetchURL + '/api/v1/scores/peers/', {
        //     params: {
        //         role_id: this.roleId,
        //     }
        // }),
        axios.get(this.fetchURL + '/api/v1/graphs/', {
          params: {
            country_id: this.countryId,
          },
        }),
      ])
      // .then(axios.spread((objectivesResponse, reasoningResponse, scoringResponse, graphResponse) => {
      .then(
        axios.spread((objectivesResponse, graphResponse) => {
          // this.fetchReasoningResponse(reasoningResponse);
          // this.fetchPeerRankingResponse(scoringResponse);
          this.fetchGraphDataResponse(graphResponse);
          this.fetchObjectivesResponse(objectivesResponse);
        })
      )
      .catch((error) => {
        console.log(error.response);
      });
  };

  /*
      Fetch the medal award scaling (bronze value, silver, etc)
    */
  fetchObjectivesResponse = (response) => {
    // console.group("Dashboard:fetchObjectives");

    // console.log(response.data.data);
    let objectives = response.data.data;
    let displayObjectives = {};
    Object.keys(objectives)
      .filter((obj) => objectives[obj].display)
      .forEach((obj) => {
        const metricName = obj.toLowerCase();
        const metricsInfo = this.props.metrics.metrics[metricName];
        const metricValue = metricsInfo[metricsInfo.length - 1];

        const levels = objectives[obj].levels;

        if (metricName === 'budgetou') {
          let ametricValue = Math.abs(metricValue);
          displayObjectives[obj] = {
            ...objectives[obj],
            value: ametricValue,
            achieved:
              ametricValue <= levels[0]
                ? 'platinum'
                : ametricValue <= levels[1]
                  ? 'gold'
                  : ametricValue <= levels[2]
                    ? 'silver'
                    : ametricValue < levels[3]
                      ? 'bronze'
                      : 'incomplete',
          };
        }

        if (metricName === 'debt') {
          displayObjectives[obj] = {
            ...objectives[obj],
            value: metricValue,
            achieved:
              metricValue <= levels[0]
                ? 'platinum'
                : metricValue <= levels[1]
                  ? 'gold'
                  : metricValue <= levels[2]
                    ? 'silver'
                    : metricValue < levels[3]
                      ? 'bronze'
                      : 'incomplete',
          };
        }

        if (metricName !== 'budgetou' && metricName !== 'debt') {
          displayObjectives[obj] = {
            ...objectives[obj],
            value: metricValue,
            achieved:
              metricValue >= levels[0]
                ? 'platinum'
                : metricValue >= levels[1]
                  ? 'gold'
                  : metricValue >= levels[2]
                    ? 'silver'
                    : metricValue > levels[3]
                      ? 'bronze'
                      : 'incomplete',
          };
        }

        // displayObjectives[obj] = {
        //     ...objectives[obj],
        //     value: metricValue,
        //     achieved: metricValue >= levels[0] ? 'platinum'
        //         : metricValue >= levels[1] ? 'gold'
        //             : metricValue >= levels[2] ? 'silver'
        //                 : metricValue > levels[3] ? 'bronze'
        //                     : 'incomplete',
        // };
      });

    //This sets the current value for each objective on awards panel
    // console.log("Dashboard:Setting objectives values");
    // console.log(displayObjectives);
    this.setState({
      objectives: displayObjectives,
    });

    console.groupEnd();
  };

  fetchGraphDataResponse = (response) => {
    // console.group("Dashboard:fetchGraphData");
    // console.log(response.data.data);
    // console.groupEnd();

    if (response.data.success) {
      const plotData = response.data.data;

      this.setState({
        plotData: plotData,
      });
    } else {
      this.setState({
        plotData: {},
      });
      // console.log(" Unable to fetch graph data.")
    }
  };

  // fetchReasoningResponse = (response) => {
  //
  //     console.group("Dashboard:fetchReasoning");
  //     console.log(response.data.data);
  //     console.groupEnd();
  //     let reasoning = response.data.data;
  //
  //     this.setState({
  //         reasoning: reasoning,
  //     });
  //
  // };

  // fetchPeerRankingResponse = (response) => {
  //
  //     console.group("Dashboard:fetchPeerRanking");
  //     console.log(response.data.data);
  //     console.groupEnd();
  //     let rankingAllowed = response.data.data;
  //
  //     this.setState({
  //         rankingAllowed: rankingAllowed,
  //     });
  //
  // };

  updateMetrics = () => {
    // console.group("Dashboard:fetchMetrics");
    return this.props.metrics
      .fetchMetrics(this.countryId)
      .then(() => {
        let metricsInfo = this.props.metrics.metrics;
        let metrics = {};
        Object.keys(metricsInfo)
          .filter(
            (m) =>
              ![
                'forecast_attempts',
                'atgfund',
                'budget',
                'role_policy_assignment',
                'round_number',
              ].includes(m)
          )
          .sort()
          .forEach((metric) => {
            metrics[metric] = {
              ...this.state.metrics[metric],
              text: () => {
                switch (metric) {
                  case 'next_budget':
                    return "This year's budget";
                  case 'budgetou':
                    return '% over/under budget';
                  case 'cost':
                    return 'Policy costs from last year';
                  case 'discord':
                    return '% Discord between HRX & Favorability';
                  case 'employ':
                    return '% migrants employed';
                  case 'favorability':
                    return '% popularity of refugees';
                  case 'gdp':
                    return 'compared to baseline';
                  case 'hrt':
                    return 'Human Rights Index (0-100)';
                  case 'eqt':
                    return 'Equity Index (0-100)';
                  case 'debt':
                    return '% debt';
                  case 'year':
                    return '';
                  default:
                    return null;
                }
              },
              value: () => {
                switch (metric) {
                  case 'next_budget':
                    return `$${nFormatter(metricsInfo[metric], 1)}`;
                  case 'cost':
                    return `$${nFormatter(
                      metricsInfo[metric][metricsInfo[metric].length - 1],
                      1
                    )}`;
                  case 'discord':
                    return `${nFormatter(
                      metricsInfo[metric][metricsInfo[metric].length - 1],
                      1
                    )}`;
                  case 'employ':
                    return (
                      metricsInfo[metric] &&
                      metricsInfo[metric][
                        parseInt(metricsInfo['year']) - 2030
                      ].toFixed(2)
                    );
                  case 'favorability':
                    return (
                      metricsInfo[metric] &&
                      metricsInfo[metric][
                        parseInt(metricsInfo['year']) - 2030
                      ].toFixed(2)
                    );
                  case 'budgetou':
                    return (
                      metricsInfo[metric] &&
                      metricsInfo[metric][
                        parseInt(metricsInfo['year']) - 2030
                      ].toFixed(2)
                    );
                  case 'debt':
                    return (
                      metricsInfo[metric] &&
                      metricsInfo[metric][
                        parseInt(metricsInfo['year']) - 2030
                      ].toFixed(2)
                    );
                  case 'gdp':
                    return (
                      metricsInfo[metric] &&
                      metricsInfo[metric][
                        parseInt(metricsInfo['year']) - 2030
                      ].toFixed(2)
                    );
                  case 'eqt':
                    return (
                      metricsInfo[metric] &&
                      metricsInfo[metric][
                        parseInt(metricsInfo['year']) - 2030
                      ].toFixed(2)
                    );
                  case 'hrt':
                    return (
                      metricsInfo[metric] &&
                      metricsInfo[metric][
                        parseInt(metricsInfo['year']) - 2030
                      ].toFixed(2)
                    );
                  case 'year':
                    return metricsInfo[metric];
                  default:
                    return null;
                }
              },
            };
          });
        this.setState(() => ({ metrics: metrics }));
        // console.groupEnd();
      })
      .catch((error) => {
        console.log(error.response);
        // console.groupEnd();
      });
  };

  shouldComponentUpdate = (nextProps) => {
    // if (nextProps.isGameComplete !== this.props.isGameComplete && nextProps.isGameComplete === true) {
    //     axios.get(this.fetchURL + '/api/v1/policies/reasoning/', {
    //         params: {
    //             country_id: this.countryId,
    //         }
    //     })
    //         .then((response) => this.fetchReasoningResponse(response))
    //         .catch((error) => console.log(error.response));
    // }

    // if (nextProps.updateDashboard === true) {
    //     this.updateMetrics();
    //     axios.get(this.fetchURL + '/api/v1/graphs/', {
    //         params: {
    //             country_id: this.countryId,
    //         }
    //     })
    //         .then((response) => this.fetchGraphDataResponse(response))
    //         .catch((error) => console.log(error.response));
    // }

    if (nextProps.updateDashboard === true) {
      this.updateMetrics()
        .then(this.fetchAll)
        .catch(this.fetchAll);
    }

    return true;
  };

  // submitRankings = (countries) => {
  //     this.setState({
  //         countries: countries,
  //         snackType: 'snack-ranking',
  //         snackOpen: true,
  //         snackMsg: "Are you sure you want to submit the peer rankings?"
  //     });
  // };

  // submitRankingsYes = () => {
  //     this.setState({requestSent: true,});
  //     this.handleClose();
  //     console.group("Dashboard:submitRankingsYes");
  //     console.log("Submit rankings confirmed!");
  //
  //     axios.post(this.fetchURL + '/api/v1/scores/peers/', {
  //         role_id: this.roleId,
  //         rankings: this.state.countries,
  //     })
  //         .then((response) => {
  //             this.setState({requestSent: false,});
  //             if (response.data.success) {
  //                 console.group("Dashboard:submitRankingsYes");
  //                 console.log(response.data);
  //                 console.groupEnd();
  //
  //                 this.setState({
  //                     rankingAllowed: false,
  //                     snackOpen: true,
  //                     snackMsg: response.data.message,
  //                     snackType: 'snack-success',
  //                     snackAutoHideDuration: 5000,
  //                 });
  //
  //             } else {
  //                 console.log(response.data.message);
  //                 this.setState({
  //                     snackOpen: true,
  //                     snackMsg: response.data.message,
  //                     snackType: 'snack-error',
  //                     snackAutoHideDuration: 5000,
  //                 });
  //             }
  //         })
  //         .catch((error) => {
  //             console.log(error.response);
  //             this.setState({requestSent: false,});
  //             this.setState({
  //                 snackOpen: true,
  //                 snackMsg: 'Something went wrong. Please try again later.',
  //                 snackType: 'snack-error',
  //                 snackAutoHideDuration: 5000,
  //             });
  //         });
  //     console.groupEnd();
  // };

  handleClose = () => {
    this.setState({ snackOpen: false });
  };
  render() {
    return (
      <div
        className={`dash__wrap ${
          this.props.display === 'show' ? 'active' : 'hidden'
        }`}
      >
        <Snackbar
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
          open={this.state.snackOpen}
          ContentProps={{
            'aria-describedby': 'message-id',
          }}
          className="snack"
          autoHideDuration={this.state.snackAutoHideDuration}
          onClose={this.handleClose}
          message={<span id="message-id">{this.state.snackMsg}</span>}
          action={
            this.state.snackType === 'snack-ranking'
              ? [
                  <Button
                    key="yes"
                    color="inherit"
                    onClick={this.submitRankingsYes}
                  >
                    Yes
                  </Button>,
                  <Button key="no" color="inherit" onClick={this.handleClose}>
                    No
                  </Button>,
                ]
              : []
          }
        />

        <div className="dash__outer pb4">
          {/*{this.props.isGameComplete && this.state.rankingAllowed &&*/}
          {/*<div className="flex flex-items-center flex-justify-center gap__container">*/}
          {/*<div className="metrics__container">*/}
          {/*<div className={`shadow metrics__wrapper`}>*/}
          {/*<h3>Rank your peers</h3>*/}
          {/*<hr/>*/}
          {/*<PeerRanking countries={this.state.countries} submitRankings={this.submitRankings}*/}
          {/*requestSent={this.state.requestSent}/>*/}
          {/*</div>*/}
          {/*</div>*/}
          {/*</div>*/}
          {/*}*/}

          {/*{this.props.isGameComplete &&*/}
          {/*<div className="flex flex-items-center flex-justify-center gap__container">*/}
          {/*<div className="metrics__container">*/}
          {/*<div className={`shadow metrics__wrapper`}>*/}
          {/*<h3>Summary of the Game</h3>*/}
          {/*<hr/>*/}

          {/*{Object.keys(this.state.reasoning).map(year => (*/}
          {/*<div key={`reasoning-${year}`}>*/}
          {/*<p>Your reasoning for the decisions for the*/}
          {/*year <strong>{year}</strong>: {this.state.reasoning[year]}</p>*/}
          {/*</div>*/}
          {/*))}*/}
          {/*<p><em>If no one had enacted: </em></p>*/}
          {/*</div>*/}
          {/*</div>*/}
          {/*</div>*/}
          {/*}*/}

          <div className="flex flex-items-center flex-justify-center gap__container">
            <div className="metrics__container">
              <div className={`shadow metrics__wrapper`}>
                <h3>Objectives</h3>
                <hr />
                {Object.keys(this.state.objectives)
                  .sort()
                  .map((obj) => {
                    const item = this.state.objectives[obj];
                    return (
                      <div
                        className="flex flex-wrap flex-40-60"
                        key={`obj-${obj}`}
                      >
                        <div className="container p1">
                          <strong>{item.text}</strong>
                        </div>
                        <div className="flex flex-justify-between container">
                          <div className={`container p1`}>
                            <h4>
                              Current:{' '}
                              <span className="objValue">
                                {item.value.toFixed(2)}
                              </span>
                            </h4>
                          </div>
                          <div
                            className={`container objCompletionLevel-bronze p1 ${
                              item.achieved === 'bronze' ? 'completedLevel' : ''
                            }`}
                          >
                            {parseFloat(item.levels[3]).toFixed(2)}
                          </div>
                          <div
                            className={`container objCompletionLevel-silver p1 ${
                              item.achieved === 'silver' ? 'completedLevel' : ''
                            }`}
                          >
                            {parseFloat(item.levels[2]).toFixed(2)}
                          </div>
                          <div
                            className={`container objCompletionLevel-gold p1 ${
                              item.achieved === 'gold' ? 'completedLevel' : ''
                            }`}
                          >
                            {parseFloat(item.levels[1]).toFixed(2)}
                          </div>
                          <div
                            className={`container objCompletionLevel-platinum p1 ${
                              item.achieved === 'platinum'
                                ? 'completedLevel'
                                : ''
                            }`}
                          >
                            {parseFloat(item.levels[0]).toFixed(2)}
                          </div>
                        </div>
                      </div>
                    );
                  })}
              </div>
            </div>
          </div>

          <div className="flex flex-items-center flex-justify-center gap__container">
            <div className="metrics__container">
              <div className={`shadow metrics__wrapper`}>
                <h3>Key Metrics</h3>
                <hr />
                <div className="flex-grid-3">
                  {Object.keys(this.state.metrics).map((item, index) => {
                    if (item !== 'costs_data') {
                      return (
                        <Metrics
                          key={`metric${index}`}
                          data={this.state.metrics[item]}
                        />
                      );
                    }
                  })}
                </div>
              </div>
            </div>
          </div>

          <div className="flex flex-items-center flex-justify-center gap__container">
            <div className="graphs__container">
              <div className={`shadow graphs__wrapper`}>
                <h3>Graphs</h3>
                <hr />

                <GraphManager plotData={this.state.plotData} />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

Dashboard.propTypes = {
  display: PropTypes.string.isRequired,
  isGameComplete: PropTypes.bool.isRequired,
  updateDashboard: PropTypes.bool.isRequired,
};

export default inject('metrics', 'countries')(Dashboard);
